// extracted by mini-css-extract-plugin
module.exports = {"tabletWidth":"768px","desktopWidth":"1088px","widescreenWidth":"1280px","fullhdWidth":"1472px"};